<template>
  <v-tour
    name="reportTour"
    :steps="steps"
    :callbacks="myCallbacks"
    v-if="$route.name === 'suspicious-traffic'"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-for="(step, index) of tour.steps"
          v-if="tour.currentStep === 0"
          :key="index"
          :step="step"
          :skip="tour.skip"
          :labels="tour.labels"
        >
          <template>
            <div slot="header" class="header">
              <div>
                New! Get recurrent reports
              </div>
              <div class="icon-times">
                <fa icon="times" @click="tour.skip"></fa>
              </div>
            </div>
            <div slot="content" class="content">
              <template>
                <p>
                  Receive recurring reports to quickly know if your network is
                  sending suspicious traffic.
                </p>
                <p>
                  <strong>Click on “Get report”</strong> to view this feature.
                </p>
              </template>
            </div>
            <div slot="content" class="content"></div>
            <div slot="actions" class="actions"></div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
export default {
  data() {
    return {
      myCallbacks: {
        onSkip: this.onSkip
      },
      steps: [
        {
          target: '#v-step-7',
          params: {
            highlight: true,
            enableScrolling: false,
            placement: 'right'
          }
        }
      ]
    };
  },
  methods: {
    onSkip() {
      localStorage.setItem('report_tour_status', 'done');
      this.$tours['reportTour'].stop();
    }
  },
  destroyed() {
    if (this.$tours['reportTour']) {
      this.$tours['reportTour'].skip();
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tour {
  & /deep/ {
    .v-step[x-placement^='bottom'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    .v-step[x-placement^='top'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    .v-step[x-placement^='right'] .v-step__arrow {
      border-color: #023957;
      border-left-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
    }

    .v-step[x-placement^='left'] .v-step__arrow {
      border-color: #023957;
      border-right-color: transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
    }
  }
  .v-step {
    background: #023957;
    padding: 0;
    max-width: 310px;
  }

  .icon-times {
    cursor: pointer;
  }

  .header {
    display: flex;
    padding: 10px;
    border-bottom: 1px solid white;
    justify-content: space-between;
    font-weight: 600;
    text-align: left;
  }
  .content {
    padding: 10px;
    text-align: left;
    p {
      color: white;
    }
  }
  .actions {
    height: 0;
  }
}
</style>
